import { render } from "./AccountView.vue?vue&type=template&id=79fed82f"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__